module.exports = __webpack_public_path__ + "img/thumbnail_BorneanElephant_f_normal.dafe44d3.png";